import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Components } from 'Route/routes';
import rootStore from 'Store/createStore';
import { injectReducer } from 'Store/reducers';
import { injectSaga } from 'Store/sagas';
import history from 'Utility/history';
import PortalLoader from 'Components/PortalLoader';
import { Grid } from '@mui/material';

export const LazyComponent = (props) => {
  const { componentName, pluginReducer, pluginSaga, hasReducer, hasSaga } = props;

  if (pluginReducer === undefined && hasReducer) {
    import(`Route/${componentName}/modules/${componentName}Reducers`)
      .then(({ default: reducer }) => {
        if (reducer !== undefined) {
          injectReducer(rootStore, { key: componentName, asyncReducer: reducer });
        }
      });
  }

  if (pluginSaga === undefined && hasSaga) {
    import(`Route/${componentName}/modules/${componentName}Sagas`)
      .then(({ default: saga }) => {
        if (saga !== undefined) {
          injectSaga(rootStore, { key: componentName, asyncSaga: saga }, history);
        }
      });
  }

  if (pluginReducer) {
    injectReducer(rootStore, { key: componentName, asyncReducer: pluginReducer, },);
  }

  if (pluginSaga) {
    injectSaga(rootStore, { key: `${componentName}`, asyncSaga: pluginSaga, }, history,);
  }

  const Component = Components[componentName];
  return (
    <Suspense fallback={
      <Grid container justifyContent="center" alignItems="center" className="lazy_component_container">
        <PortalLoader />
      </Grid>
    }>
      <Component {...props} />
    </Suspense>
  );
};

LazyComponent.propTypes = {
  componentName: PropTypes.string.isRequired,
  pluginReducer: PropTypes.func,
  pluginSaga: PropTypes.func,
  hasReducer: PropTypes.bool,
  hasSaga: PropTypes.bool
};

LazyComponent.defaultProps = {
  pluginReducer: undefined,
  pluginSaga: undefined,
  hasReducer: false,
  hasSaga: false
};

export default LazyComponent;
